
import Slider from "react-slick";
import { oneSliderSetting } from "../../api/sliderSetting";
import millVideoMp4 from "../../images/technology/mill.mp4"
import millVideoWebm from "../../images/technology/mill.webm"
import millPoster from "../../images/technology/mill_poster.jpg"
import scannerVideoMp4 from "../../images/technology/scanner.mp4"
import scannerVideoWebm from "../../images/technology/scanner.webm"
import scannerPoster from "../../images/technology/scanner_poster.jpg"
import printerVideoMp4 from "../../images/technology/3dprinter.mp4"
import printerVideoWebm from "../../images/technology/3dprinter.webm"
import printerPoster from "../../images/technology/3dprinter_poster.jpg"

const technologyInfo = [
    {
        videoMp4: millVideoMp4,
        videoWebm: millVideoWebm,
        poster: millPoster,
        description: "Experience precision and consistent results with our 5-axis zirconia mill, now with a guaranteed 3-day crown turnaround.",
        imgDescription:"zirconia_mill_machine"
    }, 
    {
        videoMp4: scannerVideoMp4,
        videoWebm: scannerVideoWebm,
        poster: scannerPoster,
        description: "Along with digital X-rays that instantly capture and display images on a computer screen, we also use an intraoral camera to take real-life photos of your teeth—making it easier to explain treatment recommendations. Recently, we’ve added an advanced intraoral scanner that creates highly accurate digital impressions. These scans can be sent directly to the lab for creating crowns, retainers, bridges, and implant restorations.",
        imgDescription:"scanner_machine"
    },
    {
        videoMp4: printerVideoMp4,
        videoWebm: printerVideoWebm,
        poster: printerPoster,
        description: "Our state-of-the-art 3D printer brings digital smile designs to life, creating precise physical mock-ups that let patients see, touch, and experience their new smile before starting treatment",
        imgDescription:"3dprinter_machine"
    }, 
]
export const TechnologySection = (props) => {
  return (
    <section id="technology-section" className={`wpo-hero-section section-padding ${props.class}`}>
      <div className="container">

        <Slider {...oneSliderSetting} >
            {
                technologyInfo.map((info, idx) =>(
                    <div key="imgIdx" className='img-holder'>
                        <OneTechnologySection description={info.description} videoMp4={info.videoMp4} videoWebm={info.videoWebm} poster={info.poster} imgDescription={idx}/>
                    </div>
                ))
            }
          </Slider>
      
      </div>
    </section>
    
  )
}
const  OneTechnologySection = ({description, videoMp4, videoWebm, poster, imgDescription}) => {
    return (
      <div className="row " style={{ justifyContent: "space-between", alignItems: "center" }}>
        <div className="col-lg-5 col-md-12 col-12" >
            <div className="wpo-section-title">
              <span>Technology</span>
              <h1>Our Cool Technologies</h1>
            </div>
            
            <div>
              <p >
                {description}
              </p>
            </div>
          
        </div>

        {/* PIC ON THE RIGHT */}
        <div className="col-lg-6 col-md-12 col-12 d-flex justify-content-center align-items-center">
          <video
            className="img-fluid"
            style={{ width: "100%", maxWidth: "700px", height: "auto", objectFit: "contain" }}
            poster={poster}
            autoPlay
            loop
            muted
            playsInline
            aria-label={imgDescription}
          >
            <source src={videoWebm} type="video/webm" />
            <source src={videoMp4} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
      </div>
  );
}
